<template>

    <b-card>
        <b-row class="mb-2">

            <b-col lg="12"><h4><strong>Filters</strong></h4></b-col>

            <b-col lg="4">

                <b-form-group label="Parent Carrier" label-for="parent_carrier_id">

                    <carrier-parents-dropdown v-model="parent_carrier"></carrier-parents-dropdown>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>

            <b-col>

                <b-button @click="loadItems()" variant="info" :disabled="loading || busy">Generate</b-button>
            </b-col>
        </b-row>

        <hr />

        <div>
            <b-row class="mb-2">
                <b-col lg="6">
                    <b-btn variant="success" :href="url + '&export=1'" :disabled="loading || busy">
                        <i class="fa fa-file-excel-o"></i> Export to Excel
                    </b-btn>
                </b-col>
                <b-col lg="6" class="text-right">
                    <b-form-input v-model="filter" placeholder="Type to Search" />
                </b-col>
            </b-row>

            <div v-if="loading" class="text-center mt-3">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <p>Loading Results...</p>
            </div>

            <b-table v-else bordered striped hover show-empty responsive
                     :items="items"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(claimant_name)="row">
                    <a :href="`/business/clients/${row.item.claimant_id}`">{{ row.value }}</a>
                </template>
            </b-table>
            <b-row>
                <b-col lg="6" >
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </b-col>
                <b-col lg="6" class="text-right">
                    Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
    export default {
        props: {
            'defaults': [Object, Array],
        },

        data() {

            return {

                loading           : false,
                totalRows         : 0,
                perPage           : 25,
                currentPage       : 1,
                sortBy            : null,
                sortDesc          : false,
                filter            : null,
                parent_carrier    : this.getDefault('parent_carrier'),
                fields: [
                    {
                        key: 'carrier',
                        label: 'Carrier',
                        sortable: true,
                    },
                    {
                        key: 'claimant_id',
                        label: 'Claimant ID',
                        sortable: true,
                    },
                    {
                        key: 'claimant_name',
                        label: 'Claimant Name',
                        sortable: true
                    },
                    {
                        key: 'claimant_enrollment_status',
                        label: 'Enrollment Status',
                        sortable: true
                    },
                    {
                        key: 'claimant_created_at',
                        label: 'Created At',
                        sortable: true
                    },
                    {
                        key: 'claimant_enrolled_at',
                        label: 'Enrolled At',
                        sortable: true
                    },
                    {
                        key: 'intake_id_or_claim_number',
                        label: 'Intake ID/Claim Number',
                        sortable: true
                    },
                    {
                        key: 'policy_number',
                        label: 'Policy Number',
                        sortable: true
                    },
                    {
                        key: 'claimant_active',
                        label: 'Active',
                        sortable: true
                    },
                    {
                        key: 'timezone',
                        label: 'Timezone',
                        sortable: true
                    },
                    {
                        key: 'first_outbound_call_date',
                        label: 'First Outbound Call Date',
                        sortable: true
                    },
                    {
                        key: 'last_outbound_call_date',
                        label: 'Last Outbound Call Date',
                        sortable: true
                    },
                    {
                        key: 'outbound_call_count',
                        label: 'Outbound Call Count',
                        sortable: true
                    },
                    {
                        key: 'first_inbound_call_date',
                        label: 'First Inbound Call Date',
                        sortable: true
                    },
                    {
                        key: 'last_inbound_call_date',
                        label: 'Last Inbound Call Date',
                        sortable: true
                    },
                    {
                        key: 'inbound_call_count',
                        label: 'Inbound Call Count',
                        sortable: true
                    },
                    {
                        key: 'claimant_caregiver_pairs',
                        label: 'Claimant Caregiver Pairs',
                        sortable: true
                    },
                    {
                        key: 'enrolled_caregivers',
                        label: 'Enrolled Caregivers',
                        sortable: true
                    },
                    {
                        key: 'who_to_enroll',
                        label: 'Who To Enroll',
                        sortable: true
                    },
                    {
                        key: 'sister_policy',
                        label: 'Sister Policy',
                        sortable: true
                    },
                    {
                        key: 'decommissioned_at',
                        label: 'Decommissioned At',
                        sortable: true
                    }
                ],
                items: [],
                busy: false,
            }
        },

        computed: {
            url() {
                return `/business/reports/enrollment?json=1&parent_carrier=${this.parent_carrier}`;
            },
        },

        methods: {
            async loadItems() {
                this.loading = true;
                this.items = [];
                try {
                    const {data} = await axios.get(this.url);
                    this.items = data;
                    this.totalRows = data.length;
                } finally {
                    this.loading = false;
                }
            },

            getDefault(field, defaultValue = '') {
                if (this.defaults && this.defaults[field]) {
                    return this.defaults[field];
                }
                return defaultValue;
            },

            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            }
        }
    }
</script>
